import './index.css';
import React, { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { createElement, editElement, removeElement } from '../../services/element.service';
import { Link, Typography } from '@mui/material';
import HandleForm from './HandleForm';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { ElementForm } from '../../models/element.model';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import useUser from "../../hooks/useUser";
import ConfirmModal from '../common/ConfirmModal';
import PrimaryMenuBar from '../ElementActions/ElementViewActions';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { APIResponseModel } from '../../models/api-call';
import { useNotification } from '../../context/NotificationContext';


interface ElementCreateFormProps {
  elementForm: ElementForm;
  element_code?: string;
  setBlockScreen: (p: boolean) => void;
  handleChange?: (e: any) => void;
  handleSelection?: (...args: any[]) => void;
  action: string
}

const ElementCreateForm: React.FC<ElementCreateFormProps> = ({
  elementForm,
  element_code = '',
  setBlockScreen,
  handleSelection,
  handleChange,
  action }) => {
    const navigate = useNavigate()
    const { selectedProject } = useProject()
    const { showNotification } = useNotification();

    const [currentAction, setCurrentAction] = useState<string>(action)
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false)
    const { userAdmin } = useUser()

    const onSubmit: SubmitHandler<ElementForm> = () => {
      setBlockScreen(true);
      Promise.all([currentAction === 'create' ? createElement(selectedProject, elementForm) :
        editElement(selectedProject, element_code, elementForm)]).then(function (results: APIResponseModel[]) {
          showNotification(
          <Typography component='span'>
            <i>Ver Elemento: </i>
            <Link
              sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
              underline='hover'
              href={`/${selectedProject}/element/view/${results[0].data['element_code']}`}
            >
              {results[0].data['element_name']}
            </Link>
          </Typography>)
        setBlockScreen(false);
        navigate('/elements/listing')
      }).catch((error) => {
        showNotification(error.response.data.message, 'error')
        setBlockScreen(false)
    });
  };

  const onSubmitDelete = () => {
    setBlockScreen(true)
    Promise.all([removeElement(selectedProject, element_code)]).then(function (result: any[]) {
      showNotification(<span>Se ha removido el Elemento: <i>{elementForm.name}</i></span>)
      setOpenConfirmRemoveModal(false)
      setBlockScreen(false)
      navigate('/elements/listing')
    }).catch((error) => {
      setOpenConfirmRemoveModal(false)
      showNotification(error.response.data.message, 'error')
      setBlockScreen(false)
      setTimeout(() => navigate('/elements/listing'), 1500)
    });
  }

  return (
    <React.Fragment>
      {currentAction !== 'create' &&

        (<div className='element-indicators-actions-section'>
          <div className='element-inidicators-section'>
            <IndicatorChip
              label={`Fecha de creación ${elementForm.created_date}`}
              iconDecoration={<EventAvailableOutlinedIcon />}
            />
          </div>

          <PrimaryMenuBar
            action={currentAction}
            setCurrentAction={setCurrentAction}
            handleRemove={() => setOpenConfirmRemoveModal(true)}
            canEdit={userAdmin}
          />
        </div>
        )}

      <HandleForm
        action={currentAction}
        setBlockScreen={setBlockScreen}
        handleChange={handleChange}
        handleSelection={handleSelection}
        onSubmit={onSubmit}
        elementForm={elementForm}
        selectedProject={selectedProject}
      />

      <ConfirmModal
        openModal={openConfirmRemoveModal}
        handleCloseModal={() => setOpenConfirmRemoveModal(false)}
        handleConfirm={onSubmitDelete}
      >
        <p>¿ Remover Elemento: {elementForm.name} ?</p>
      </ConfirmModal>

    </React.Fragment>
  );
}

export default ElementCreateForm;